import {
  Bot,
  Building,
  ChartScatter,
  ClipboardList,
  Cog,
  FileText,
  Map,
  Package,
  Wrench,
} from 'lucide-react'
import React from 'react'
import { RolodexEntryType } from 'types'

export interface EntryTypeMetadata {
  icon: React.ComponentType
  displayName: string
  pluralName: string
}

export const ENTRY_TYPE_CONFIG: Partial<
  Record<RolodexEntryType, EntryTypeMetadata>
> = {
  [RolodexEntryType.UNIT]: {
    icon: Package,
    displayName: 'Unit',
    pluralName: 'Units',
  },
  [RolodexEntryType.INSPECTION]: {
    icon: Wrench,
    displayName: 'Inspection',
    pluralName: 'Inspections',
  },
  [RolodexEntryType.COMPONENT]: {
    icon: Cog,
    displayName: 'Component',
    pluralName: 'Components',
  },
  [RolodexEntryType.JOB]: {
    icon: ClipboardList,
    displayName: 'Job',
    pluralName: 'Jobs',
  },
  [RolodexEntryType.ASSET_MODEL]: {
    icon: Building,
    displayName: 'Asset Model',
    pluralName: 'Asset Models',
  },
  [RolodexEntryType.SITE]: {
    icon: Map,
    displayName: 'Site',
    pluralName: 'Sites',
  },
  [RolodexEntryType.SYSTEM]: {
    icon: Cog,
    displayName: 'System',
    pluralName: 'Systems',
  },
  [RolodexEntryType.VALUE_STORY]: {
    icon: FileText,
    displayName: 'Value Story',
    pluralName: 'Value Stories',
  },
  [RolodexEntryType.EQUIPMENT]: {
    icon: Bot,
    displayName: 'Equipment',
    pluralName: 'Equipment',
  },
  [RolodexEntryType.CHART]: {
    icon: ChartScatter,
    displayName: 'Chart',
    pluralName: 'Charts',
  },
}

const DEFAULT_METADATA: EntryTypeMetadata = {
  icon: FileText,
  displayName: 'Entry',
  pluralName: 'Entries',
}

export const getEntryTypeMetadata = (
  type: RolodexEntryType
): EntryTypeMetadata => {
  return ENTRY_TYPE_CONFIG[type] || DEFAULT_METADATA
}

export const getEntryTypeIcon = (
  type: RolodexEntryType
): React.ComponentType => {
  return getEntryTypeMetadata(type).icon
}

export const getEntryTypeDisplayName = (type: RolodexEntryType): string => {
  return getEntryTypeMetadata(type).displayName
}

export const getEntryTypePluralName = (type: RolodexEntryType): string => {
  return getEntryTypeMetadata(type).pluralName
}
